export default "__VITE_ASSET__xLe80_89__"